import { Box, Button, Text, Title } from '@holbonkit/ui'

import { currencyParser } from '@/shared/lib/currency-parser'

import { PopoverDeducted, PopoverUpcoming, PopoverWithdrawal } from '../popover/popover'

import styles from './carousel-content.module.scss'

type TPopoverControl = {
    isOpen: boolean
    setIsOpen: (isOpen: boolean) => void
}

type TCarouselContentProps = {
    balances: {
        available: number
        deducted: number
        upcoming: number
    }
    onAbout: () => void
    onWithdraw: () => void
    popovers: {
        deducted: TPopoverControl
        upcoming: TPopoverControl
        withdrawal: TPopoverControl
    }
}

export const CarouselContent = ({
    balances,
    onAbout,
    onWithdraw,
    popovers,
}: TCarouselContentProps) => {
    return [
        <Box key={0} className={styles['carousel-item']}>
            <Text variant='body-m-16-medium'>Доступно для вывода</Text>
            <Box className={styles[`carousel-item--amount`]}>
                <Title variant='extra-48-bold'>{currencyParser(balances.available)}</Title>
                <Title
                    className={styles[`carousel-item--amount--currency`]}
                    variant='extra-48-bold'
                >
                    ₽
                </Title>
            </Box>
            <Text className={styles[`carousel-item--hint`]} variant='body-m-16-regular'>
                Еще {currencyParser(balances.upcoming)} ₽ скоро зачислятся
                <PopoverUpcoming
                    isPopoverOpen={popovers.upcoming.isOpen}
                    setIsPopoverOpen={popovers.upcoming.setIsOpen}
                />
            </Text>
            <Button
                className={styles[`carousel-item--button`]}
                disabled={balances.available === 0}
                variant='primary'
                onClick={onWithdraw}
            >
                Вывести
            </Button>
            <PopoverWithdrawal
                isPopoverOpen={popovers.withdrawal.isOpen}
                setIsPopoverOpen={popovers.withdrawal.setIsOpen}
            />
        </Box>,
        <Box key={1} className={styles['carousel-item']}>
            <Text variant='body-m-16-medium'>Удержано за этот месяц</Text>
            <Box className={styles[`carousel-item--amount`]}>
                <Title variant='extra-48-bold'>{currencyParser(balances.deducted)}</Title>
                <Title
                    className={styles[`carousel-item--amount--currency`]}
                    variant='extra-48-bold'
                >
                    ₽
                </Title>
            </Box>
            <Button
                className={styles[`carousel-item--button`]}
                variant='secondary'
                onClick={onAbout}
            >
                Подробнее
            </Button>
            <PopoverDeducted
                isPopoverOpen={popovers.deducted.isOpen}
                setIsPopoverOpen={popovers.deducted.setIsOpen}
            />
        </Box>,
    ]
}
